import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "@mantine/core/styles.css";
import "@mantine/carousel/styles.css";
import "@mantine/dates/styles.css";
import "react-international-phone/style.css";
import "react-image-lightbox/style.css";
import "./index.css";
import { Provider } from "jotai";
import { myStore } from "./store/jotaiStore";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <Provider store={myStore}>
    <App />
  </Provider>
);
